import DOMPurify from 'dompurify';
import { EMAIL_TEMPLATE_FILL_FIELD_ATTRIBUTE, EMAIL_TEMPLATE_PLACEHOLDER_ATTRIBUTE } from '@immo/api-contract';

// The same body allow-list as the server's e-mail-template sanitiser: formatting,
// lists, links (http, https, mailto) and the two chip markers. The server stays
// authoritative; this runs only where stored markup becomes live DOM in the
// editor, as defence in depth.
const ALLOWED_TAGS = ['div', 'p', 'br', 'b', 'strong', 'i', 'em', 'u', 'ul', 'ol', 'li', 'a', 'span'];
const CHIP_ATTRIBUTES = [EMAIL_TEMPLATE_PLACEHOLDER_ATTRIBUTE, EMAIL_TEMPLATE_FILL_FIELD_ATTRIBUTE];
const SAFE_URI = /^(?:https?:|mailto:)/i;

export function sanitiseEmailTemplateHtml(dirty: string): string {
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS,
    ALLOWED_ATTR: ['href', ...CHIP_ATTRIBUTES],
    ADD_URI_SAFE_ATTR: CHIP_ATTRIBUTES,
    ALLOW_DATA_ATTR: false,
    ALLOWED_URI_REGEXP: SAFE_URI,
  });
}
